export default __webpack_public_path__ + "static/media/444.ff498475.png";